import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { InvoicingComponent } from './invoicing.component';
import { InvoicingRoutingModule } from './invoicing-routing.module';
import { InvoicingResolve } from './invoicing.resolve';
import { ManualPaymentModalComponent } from '../../../shared/modals/manual-payment/manual-payment-modal.component';
import { ManualPaymentModalModule } from '../../../shared/modals/manual-payment/manual-payment-modal.module';
import { TransactionChickenTestComponent } from '../../../shared/modals/transaction-chicken-test/transaction-chicken-test.component';
import { CardNameMatcherModule } from './card-name-matcher/card-name-matcher.module';
import { LoadingModule } from '../../../shared/loading/loading.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    InvoicingRoutingModule,
    MatDialogModule,
    MatFormFieldModule,
    ManualPaymentModalModule,
    CardNameMatcherModule,
    LoadingModule,
    MatProgressBarModule,
  ],
  declarations: [InvoicingComponent, TransactionChickenTestComponent],
  entryComponents: [
    ManualPaymentModalComponent,
    TransactionChickenTestComponent,
  ],
  exports: [InvoicingComponent],
  providers: [InvoicingResolve],
})
export class InvoicingModule {}
